<template>
  <div>
    <b-card>
      <title-text />
      <content-text />
    </b-card>
    <image-card />
  </div>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/Laboratory_services/elements/TitleText.vue'
import ContentText from '@/views/Admin/Laboratory_services/elements/ContentText.vue'
import ImageCard from '@/views/Admin/Laboratory_services/elements/ImageCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    TitleText,
    ContentText,
    ImageCard,
  },
  computed: {
    dataItem() {
      return this.$store.getters['laboratoryServices/dataItem']
    },
  },
}
</script>
